import { render, staticRenderFns } from "./FilesPagination.vue?vue&type=template&id=1b1560d8&"
import script from "./FilesPagination.vue?vue&type=script&lang=js&"
export * from "./FilesPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b1560d8')) {
      api.createRecord('1b1560d8', component.options)
    } else {
      api.reload('1b1560d8', component.options)
    }
    module.hot.accept("./FilesPagination.vue?vue&type=template&id=1b1560d8&", function () {
      api.rerender('1b1560d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/FilesPagination.vue"
export default component.exports